
/*Scroll para header*/
document.addEventListener('DOMContentLoaded', function() {
  const stickyHeader = document.querySelector('sticky-header');

  window.addEventListener('scroll', function() {
    if (window.scrollY > 50) {
      stickyHeader.style.backgroundColor = 'rgba(13, 13, 13, 0.8)';
    } else {
      stickyHeader.style.backgroundColor = 'transparent'; // color original
    }
  });
});


/*Banner solo para paginas que no son index*/
document.addEventListener("DOMContentLoaded", function() {
    const pageType = document.documentElement.innerHTML;
    if (pageType.includes('"pageType":"index"')) {
      document.body.classList.add("page-home");
    }
});


/*Accordeon producto*/
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.js-toggle-accordion').forEach((header) => {
      header.addEventListener('click', () => {
        const current = header.closest('.product__accordion');

        // Cierra los demás
        document.querySelectorAll('.product__accordion').forEach((acc) => {
          if (acc !== current) {
            acc.classList.remove('active');
          }
        });

        // Alterna el actual
        current.classList.toggle('active');
      });
    });
  });